// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import Clickable from "@insite/mobius/Clickable";
import Link, { LinkProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import LazyImage, { LazyImageProps } from "@synd/MobiusOverrides/LazyImage";
import { mergeWithCss } from "@synd/XDL/Utilities/mergeWithCss";

import { ImageSettingKey } from "@synd/XDL/types";
import React, { FC, useState } from "react";

interface OwnProps {
    brand: BrandModel;
    extendedStyles?: BrandCardStyles;
}

type Props = OwnProps;

export interface BrandCardStyles {
    brandWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    image?: LazyImageProps;
    title?: LinkProps;
}

export const brandCardStyles: BrandCardStyles = {};

const BrandCard: FC<Props> = ({ brand, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(brandCardStyles, extendedStyles));

    if (!brand) {
        return null;
    }

    return (
        <StyledWrapper key={brand.id} {...styles.brandWrapper}>
            <Clickable href={brand.detailPagePath} {...styles.imageWrapper} aria-label="brand image clickable">
                <LazyImage
                    src={brand.logoSmallImagePath}
                    altText={brand.logoAltText}
                    height="100%"
                    width="100%"
                    imageKey={ImageSettingKey.brand}
                    {...styles.image}
                />
            </Clickable>
            <Link aria-label={brand.name} href={brand.detailPagePath} {...styles.title}>
                {brand.name}
            </Link>
        </StyledWrapper>
    );
};

export default BrandCard;
